import { Fragment, useContext, useState } from "react";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import { BacktoMyAccount } from "../backToMyAccount";
import { GlobalContext } from "../../../Context/GlobalContext";
import { ShippingAddressCard } from "./shippingAddressCard";
import { BillingAddressCard } from "./billingAddressCard";
import { PAGES } from "../../../routeConfig";
import { UpdateAddressPopup } from "./updateAddressPopup";
import { useAuth } from "../../../Context/AuthContext";
import { AdminOnlyAlertPopup } from "./adminonlyAlertPopup";

export const MyAccountProfile = () => {
  const { role } = useAuth();
  return (
    <Fragment>
      <BreadCrumb
        data={[
          { name: "My Account", url: "/myaccount" },
          { name: "My Account Details", url: PAGES.MYWALLET },
        ]}
      />
      <section className="myAccount-section">
        <div className="container-fluid container-lg">
          <div className="row">
            <div className="col-lg-12">
              <div className="acc-header py-3">
                <div className="myaccount-address myAccount-header">
                  <h1 className="myaccount-title">
                    My Account Details - Address
                  </h1>
                </div>
                {role == 1 ? <UpdateAddressPopup /> : <AdminOnlyAlertPopup />}
              </div>
            </div>
          </div>
          <div className="row mt-3 mt-lg-4">
            <ShippingAddressCard />
            <BillingAddressCard />
            <BacktoMyAccount />
          </div>
        </div>
      </section>
    </Fragment>
  );
};
